<ngx-pin
  [showBiometric]="hasBiometric()"
  [hasAnimation]="hasBackground()"
  [pinState]="state()"
  [disableActions]="submitting()"
  (onPinCompleted)="pinComplete($event)"
  [hint]="hint()"
  [title]="title()"
  [enterPasswordState]="enterPasswordState()"
  #pinComponent
></ngx-pin>
